import React from "react";
import { UserCard } from "../../../api/types";

interface FreezeCardTransactionsProps {
  isLoading: boolean;
  handleFreezeCard: (freeze: boolean) => void;
  userCard: UserCard | null;
}

export const FreezeCardTransactions: React.FC<FreezeCardTransactionsProps> = ({
  isLoading,
  handleFreezeCard,
  userCard,
}) => {
  return (
    <div
      onClick={() => {
        if (isLoading) return;
        handleFreezeCard(userCard?.status !== "locked");
      }}
      style={{
        borderRadius: "2px",
        border: "1px solid rgba(244,85,98,0.50)",
        backgroundColor: "rgba(244,85,98,0.08)",
        display: "flex",
        padding: "4px 8px",
        alignItems: "center",
        gap: "4px",
        color: "#F45562",
        fontSize: "12px",
        fontWeight: "500",
        cursor: isLoading ? "not-allowed" : "pointer",
        opacity: isLoading ? 0.5 : 1,
      }}
      onMouseEnter={(e) => {
        if (!isLoading) {
          e.currentTarget.style.backgroundColor = "rgba(244,85,98,0.12)";
          e.currentTarget.style.borderColor = "rgba(244,85,98,0.60)";
        }
      }}
      onMouseLeave={(e) => {
        if (!isLoading) {
          e.currentTarget.style.backgroundColor = "rgba(244,85,98,0.08)";
          e.currentTarget.style.borderColor = "rgba(244,85,98,0.50)";
        }
      }}
    >
      {userCard?.status === "locked" ? "Unfreeze Card" : "Freeze Card"}
    </div>
  );
};
